export const FETCH_FEEDBKDETAILS_INIT_ACTION = "FETCH_FEEDBKDETAILS_INIT_ACTION"
export const FETCH_FEEDBKDETAILS_SUCCESS_ACTION = FETCH_FEEDBKDETAILS_INIT_ACTION + '_SUCCESS'
export const FETCH_FEEDBKDETAILS_FAIL_ACTION = FETCH_FEEDBKDETAILS_INIT_ACTION + '_ERROR'

export const FETCH_USERS_SEARCH_INIT_ACTION = "FETCH_USERS_SEARCH_INIT_ACTION";
export const FETCH_USERS_SEARCH_SUCCESS_ACTION = FETCH_USERS_SEARCH_INIT_ACTION + "_SUCCESS";
export const FETCH_USERS_SEARCH_FAIL_ACTION = FETCH_USERS_SEARCH_INIT_ACTION + "_ERROR";

export const FETCH_FEEDBACK_BY_ID_INIT_ACTION = "FETCH_FEEDBACK_BY_ID_INIT_ACTION";
export const FETCH_FEEDBACK_BY_ID_SUCCESS_ACTION = FETCH_FEEDBACK_BY_ID_INIT_ACTION + "_SUCCESS";
export const FETCH_FEEDBACK_BY_ID_FAIL_ACTION = FETCH_FEEDBACK_BY_ID_INIT_ACTION + "_ERROR";

export function feedbkList() {

    return {
        type: FETCH_FEEDBKDETAILS_INIT_ACTION
    }
}

export function slectedPage(value) {
    // console.log("action selected page", value)
    return {
        type: FETCH_FEEDBKDETAILS_INIT_ACTION,
        value: value,
    }
}

export function searchUser(value) {

    return {
        type: FETCH_USERS_SEARCH_INIT_ACTION,
        value: value,
    }
}

export function fetchFeedbckById(value) {
    return {
        type: FETCH_FEEDBACK_BY_ID_INIT_ACTION,
        value: value
    }
}
export function feedbackPagitn(value) {
    return {
        type: FETCH_FEEDBACK_BY_ID_INIT_ACTION,
        value: value
    }
}